export const SET_NEXT_URL = "SET_NEXT_URL";
export const SET_ROUTE_REDUCER = "SET_ROUTE_REDUCER";
